import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import ExcelJS from 'exceljs';
import { ethers } from 'ethers';
import { abi, contractAddress } from './contractABI'; // Import ABI and contract address
import './Upload.css'; // Import a CSS file for custom styles

function UploadDataToContract() {
  const [status, setStatus] = useState('');
  const [walletAddress, setWalletAddress] = useState(''); // State to store wallet address
  const [isWalletConnected, setIsWalletConnected] = useState(false); // State to manage connection status

  const { getRootProps, getInputProps } = useDropzone({
    accept: '.xlsx, .xls',
    onDrop: async (files) => {
      const file = files[0];
      setStatus('Processing file...');
      const addresses = [];
      const amounts = [];

      try {
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(await file.arrayBuffer());
        const sheet = workbook.getWorksheet(1); // Assuming first sheet

        sheet.eachRow((row, rowNumber) => {
          if (rowNumber > 1) { // Skip header row
            const address = row.getCell(1).value?.toString().trim();
            const amount = row.getCell(2).value;

            if (address && amount) {
              const parsedAmount = ethers.parseEther(amount.toString());
              addresses.push(address);
              amounts.push(parsedAmount);
            }
          }
        });

        // Log addresses and amounts to check
        console.log('Addresses:', addresses);
        console.log('Amounts:', amounts);

        // Initialize ethers.js provider and signer
        const provider = new ethers.BrowserProvider(window.ethereum);
        await provider.send('eth_requestAccounts', []); // Request access to MetaMask
        const signer = await provider.getSigner();

        // Create contract instance
        const contract = new ethers.Contract(contractAddress, abi, signer);

        // Send transaction to contract
        const tx = await contract.addUsers(addresses, amounts);
        await tx.wait(); // Wait for the transaction to be mined

        console.log('Transaction:', tx);
        setStatus('Transaction successful!');
      } catch (error) {
        console.error('Error uploading file:', error);
        setStatus('Failed to upload data');
      }
    }
  });

  // Function to connect wallet and ensure it's connected to Polygon mainnet
  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const provider = new ethers.BrowserProvider(window.ethereum);
        const accounts = await provider.send('eth_requestAccounts', []);
        setWalletAddress(accounts[0]); // Set the first account as the connected wallet address

        const network = await provider.getNetwork();
        if (network.chainId !== 137) {
          // If not connected to Polygon, prompt to switch network
          try {
            await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: '0x89' }] // 137 in hexadecimal (Polygon Mainnet)
            });
            setIsWalletConnected(true);
          } catch (switchError) {
            if (switchError.code === 4902) {
              // If the network is not added to MetaMask, add it
              await window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [{
                  chainId: '0x89',
                  chainName: 'Polygon Mainnet',
                  rpcUrls: ['https://polygon-rpc.com/'],
                  nativeCurrency: {
                    name: 'POL',
                    symbol: 'POL',
                    decimals: 18
                  },
                  blockExplorerUrls: ['https://polygonscan.com/']
                }]
              });
              setIsWalletConnected(true);
            } else {
              console.error('Error switching to Polygon network:', switchError);
              setStatus('Failed to switch to Polygon network');
            }
          }
        } else {
          setIsWalletConnected(true); // Already connected to Polygon
        }
      } catch (error) {
        console.error('Error connecting to wallet:', error);
        setStatus('Failed to connect wallet');
      }
    } else {
      alert('Please install MetaMask!');
    }
  };

  return (
    <div className="upload-container">
      <h2 className="upload-title">Upload Data to Smart Contract</h2>

      {/* Wallet connect button */}
      {!isWalletConnected ? (
        <button className="connect-button" onClick={connectWallet}>
          Connect Wallet
        </button>
      ) : (
        <div className="wallet-address">
          <p>Connected Wallet: {walletAddress}</p>
        </div>
      )}

      <div className="dropzone-container" {...getRootProps()}>
        <input {...getInputProps()} />
        <p className="dropzone-text">Drag & drop your Excel file here, or <span className="upload-click">click to select one</span></p>
      </div>

      <div className={`status-message ${status.includes('Failed') ? 'error' : 'success'}`}>
        {status}
      </div>
    </div>
  );
}

export default UploadDataToContract;
